import { getRecoil, setRecoil } from "recoil-nexus";
import messagesState from "../../atoms/messages";
import participantsState from "../../atoms/participants";
import emitGetUserDetails from "../emits/getUserDetails";
import { socket } from "../index";
import { Message, MessageType, SystemMessageType } from "../type";

interface ListenReceiveJoinUserPayload {
  roomId: string;
  nickname: string;
  userId: string;
}

const listenReceiveJoinUser = () => {
  socket?.on('RECEIVE_JOIN_USER', (payload: ListenReceiveJoinUserPayload) => {
    const participants = getRecoil(participantsState);
    const messages = getRecoil(messagesState);

    if (payload.roomId === participants.roomId) {
      // Push user
      setRecoil(participantsState, {
        ...participants,
        users: [
          ...participants.users,
          payload.userId,
        ],
      });
      // Join message
      const message: Message = {
        user: payload.userId,
        messageType: MessageType.SYSTEM,
        contents: {
          systemMessageType: SystemMessageType.JOIN_USER,
        }
      };
      setRecoil(messagesState, {
        ...messages,
        messages: [
          ...messages.messages, 
          message
        ]
      });
    }

    emitGetUserDetails([payload.userId]);
  });
}

export default listenReceiveJoinUser;